import { render, staticRenderFns } from "./HomeWidgetGrid.vue?vue&type=template&id=7416d7bc&scoped=true&"
var script = {}
import style0 from "./HomeWidgetGrid.vue?vue&type=style&index=0&id=7416d7bc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7416d7bc",
  null
  
)

export default component.exports